import React from 'react';
import { graphql } from 'gatsby';
import Layout from 'components/layout';
import SEO from 'react-seo-component';
import JoinUsForm from '../components/joinForm';
import Fade from "react-reveal/Fade";
import Pill from "../vectors/pill";
import familyPic from "../images/family_pic.png"

const JoinUs = props => {
    const data = {}
    return (
        <Layout>
            <SEO
                title="Join Us"
                titleTemplate={data.default_title || "eScript360"}
                description={
                    data.default_description ||
                    'No copays, deductibles, prior authorizations, or pre-approvals. Welcome to Pharmacy Redefined.'
                }
                image={'src/images/eScript.logo.png'}
                pathname="https://www.escript360.com/about-us"
                siteLanguage="en-US"
                siteLocale="en_us"
                twitterUsername="@escript360"
            />
            {/* 
            <Hero heading={"Join Us"} /> */}

            <div className="roadblock roadblock--left">
                <div className="roadblock__inner">
                    <div className="roadblock__floaters">
                        <Fade bottom distance="4rem">
                            <div className="floater">
                                <Pill fill="#FFFFFF" />
                            </div>
                        </Fade>

                        <Fade bottom distance="4rem">
                            <div className="floater">
                                <Pill fill="#FFFFFF" />
                            </div>
                        </Fade>

                        <Fade bottom distance="4rem">
                            <div className="floater">
                                <Pill fill="#FFFFFF" />
                            </div>
                        </Fade>
                    </div>
                    <div className="roadblock__block roadblock__block--content">
                        <h2 className="roadblock__heading">
                            The healthcare system doesn't work for you, but we do.
                        </h2>
                    </div>
                    <div className="roadblock__block roadblock__block--image">
                        <img src={familyPic} alt="" />
                    </div>
                </div>
            </div>
            <div className='contact-us-page' id="contact">
                <div className='contact-us-page__inner'>
                    <div className="contact-us__wrapper">
                        <div className="contact-us__form-container roadblock--right">{/* 
                                <p className="contact-us__text">Fill out the form below and we'll get back to you within 24 hours.</p> */}
                            <JoinUsForm />
                            <Fade bottom distance="4rem">
                                <div className="floater">
                                    <Pill fill="#FFFFFF" />
                                </div>
                            </Fade>

                            <Fade bottom distance="4rem">
                                <div className="floater">
                                    <Pill fill="#FFFFFF" />
                                </div>
                            </Fade>

                            <Fade bottom distance="4rem">
                                <div className="floater">
                                    <Pill fill="#FFFFFF" />
                                </div>
                            </Fade>
                        </div>
                    </div>
                </div>
            </div>

        </Layout>
    );
}

export default JoinUs;

export const query = graphql`  
{prismic {
    allJoin_uss {
      edges {
        node {
          title
          text
          _linkType
        }
      }
    }
  }
}`;
